import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';
import { Model } from './model';

export class ResultBaseModel<T>
  extends Model
  implements IModel<ResultBaseModel<T>>
{
  @JsonProperty({ name: 'message' })
  Message: string = '';

  @JsonProperty({ name: 'status' })
  Status: number = 0;

  @JsonProperty({ name: 'result' })
  Result: T = null as any;

  static create<T>(input: any, resultType?: new () => T): ResultBaseModel<T> {
    const base = ObjectMapper.deserialize<ResultBaseModel<T>>(ResultBaseModel, input);
    const resultPayload = input?.result ?? input?.Result ?? null;

    if (resultType && resultPayload) {
      base.Result = ObjectMapper.deserialize(resultType, resultPayload);
    } else {
      base.Result = resultPayload as T;
    }

    return base;
  }
}
